import {
  PRISTINE, PENDING, FAILURE, SUCCESS,
} from 'utils/constants/queryStatuses';
import CONSTANTS from 'components/Authentication/constants';
import matchesConstants from './constants';

export const initialState = {
  status: PRISTINE,
  isFetching: false,
  error: null,
  isStale: false,
  profileUpdatedAt: null,
  trial_groups: [],
  trial_group_descriptions: {},
  trial_groups_colors: {},
  trials: [],
  treatments: [],
  treatmentsCategories: [],
  locations: [],
};

const formTreatmentsCategories = ({ treatmentCategoryTree, treatments }) => treatmentCategoryTree?.map((treatment) => ({
  ...treatment,
  treatments: treatment.nct_numbers.map((id) => treatments.find(({ nct_number }) => nct_number === id)).filter((i) => i),
}));

// eslint-disable-next-line default-param-last
export function matches(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case matchesConstants.GET_MATCHES_REQUEST:
      return {
        ...state,
        status: PENDING,
        isFetching: true,
        error: null,
      };
    case matchesConstants.GET_MATCHES_SUCCESS:
      return {
        ...state,
        ...payload,
        result_trials: [...payload.result],
        treatmentsCategories: formTreatmentsCategories(payload),
        trials: payload.result,
        isFetching: false,
        status: SUCCESS,
        error: null,
      };
    case matchesConstants.GET_MATCHES_FAILURE:
      return {
        ...state,
        status: FAILURE,
        isFetching: false,
        error: payload,
      };
    case matchesConstants.SET_MATCHES_IS_STALE:
      return {
        ...state,
        isStale: payload,
      };
    case matchesConstants.CLEAR_MATCHES:
    case CONSTANTS.LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
